<template>
  <div class="student-course-performance-panel">
    <div class="course-main">
      <div class="header">
        <div class="label">
          <i class="el-icon-collection-tag"></i>
          <span>培养计划内课程</span>
        </div>
      </div>
      <div class="body">
        <DataGrid size="mini"
                  border="inner"
                  row-id="courseId"
                  resizable
                  highlight-current-row
                  highlight-hover-row
                  :data="planCourses">
          <DataGridColumn title="课程"
                          min-width="160">
            <template #default="{row}">
              <div class="info-wrap course-wrap">
                <span>{{row.course}}</span>
              </div>
            </template>
          </DataGridColumn>
          <DataGridColumn title="学时"
                          field="creditHour"
                          min-width="60"
                          align="center"></DataGridColumn>
          <DataGridColumn title="学分"
                          field="credit"
                          min-width="60"
                          align="center"></DataGridColumn>
          <DataGridColumn field="courseType"
                          min-width="90"
                          align="center">
            <template #header>
              <div class="header-wrap">课程<br>类别</div>
            </template>
          </DataGridColumn>
          <DataGridColumn field="semester"
                          min-width="100"
                          align="center">
            <template #header>
              <div class="header-wrap">初修<br>学期</div>
            </template>
          </DataGridColumn>
          <DataGridColumn min-width="80"
                          align="center">
            <template #header>
              <div class="header-wrap">初修<br>成绩</div>
            </template>
            <template #default="{row}">
              <StudentCoursePerformanceDetail class="info-wrap"
                                              score-type="scoreCx"
                                              :student-id="studentId"
                                              :score="row"
                                              v-bind="$attrs"></StudentCoursePerformanceDetail>
            </template>
          </DataGridColumn>
          <DataGridColumn min-width="80"
                          align="center">
            <template #header>
              <div class="header-wrap">补修<br>成绩</div>
            </template>
            <template #default="{row}">
              <StudentCoursePerformanceDetail class="info-wrap"
                                              score-type="scoreBx"
                                              :student-id="studentId"
                                              :score="row"
                                              v-bind="$attrs"></StudentCoursePerformanceDetail>
            </template>
          </DataGridColumn>
          <DataGridColumn field="scoreFinal"
                          min-width="80"
                          align="center"
                          fixed="right">
            <template #header>
              <div class="header-wrap">总评<br>成绩</div>
            </template>
            <template #default="{row}">
              <StudentCoursePerformanceDetail class="info-wrap"
                                              score-type="scoreFinal"
                                              :student-id="studentId"
                                              :score="row"
                                              v-bind="$attrs"></StudentCoursePerformanceDetail>
            </template>
          </DataGridColumn>
          <template #empty>
            <span>培养计划课程数据为空</span>
          </template>
        </DataGrid>
      </div>
    </div>
    <div v-if="extraCourses && extraCourses.length"
         class="course-main">
      <div class="header">
        <div class="label">
          <i class="el-icon-collection-tag"></i>
          <span>培养计划外课程</span>
        </div>
      </div>
      <div class="body">
        <DataGrid size="mini"
                  border="inner"
                  row-id="courseId"
                  resizable
                  highlight-current-row
                  highlight-hover-row
                  :data="extraCourses">
          <DataGridColumn title="课程"
                          min-width="160">
            <template #default="{row}">
              <div class="info-wrap course-wrap">
                <span>{{row.course}}</span>
              </div>
            </template>
          </DataGridColumn>
          <DataGridColumn title="学时"
                          field="creditHour"
                          min-width="60"
                          align="center"></DataGridColumn>
          <DataGridColumn title="学分"
                          field="credit"
                          min-width="60"
                          align="center"></DataGridColumn>
          <DataGridColumn field="courseType"
                          min-width="90"
                          align="center">
            <template #header>
              <div class="header-wrap">课程<br>类别</div>
            </template>
          </DataGridColumn>
          <DataGridColumn field="semester"
                          min-width="100"
                          align="center">
            <template #header>
              <div class="header-wrap">初修<br>学期</div>
            </template>
          </DataGridColumn>
          <DataGridColumn min-width="80"
                          align="center">
            <template #header>
              <div class="header-wrap">初修<br>成绩</div>
            </template>
            <template #default="{row}">
              <StudentCoursePerformanceDetail class="info-wrap"
                                              score-type="scoreCx"
                                              :student-id="studentId"
                                              :score="row"
                                              v-bind="$attrs"></StudentCoursePerformanceDetail>
            </template>
          </DataGridColumn>
          <DataGridColumn min-width="80"
                          align="center">
            <template #header>
              <div class="header-wrap">补修<br>成绩</div>
            </template>
            <template #default="{row}">
              <StudentCoursePerformanceDetail class="info-wrap"
                                              score-type="scoreBx"
                                              :student-id="studentId"
                                              :score="row"
                                              v-bind="$attrs"></StudentCoursePerformanceDetail>
            </template>
          </DataGridColumn>
          <DataGridColumn field="scoreFinal"
                          min-width="80"
                          align="center"
                          fixed="right">
            <template #header>
              <div class="header-wrap">总评<br>成绩</div>
            </template>
            <template #default="{row}">
              <StudentCoursePerformanceDetail class="info-wrap"
                                              score-type="scoreFinal"
                                              :student-id="studentId"
                                              :score="row"
                                              v-bind="$attrs"></StudentCoursePerformanceDetail>
            </template>
          </DataGridColumn>
        </DataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import StudentCoursePerformanceDetail from './detail'
export default {
  name: 'StudentCoursePerformancePanel',
  components: {
    DataGrid,
    DataGridColumn,
    StudentCoursePerformanceDetail
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    planCourses: Array,
    extraCourses: Array
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../styles/color";
  .student-course-performance-panel {
    padding-bottom: 15px;
    & > .course-main {
      & > .header {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        & > .label {
          font-size: 12px;
        }
      }
      & > .body {
        .vxe-table {
          margin-bottom: 0;
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f9f9fa;
                .vxe-header--column {
                  .vxe-cell {
                    .vxe-cell--title {
                      color: #606266;
                      font-weight: bold;
                      .header-wrap {
                        line-height: 18px;
                      }
                    }
                  }
                }
              }
            }
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                &.project-score-not-record {
                  background-color: $set-danger-lighter-color;
                }
                .vxe-body--column {
                  .vxe-cell {
                    .info-wrap {
                      margin-top: -6px;
                      margin-bottom: -6px;
                      &.course-wrap {
                        display: flex;
                        align-items: center;
                        min-height: 40px;
                        padding: 2px 0;
                        line-height: 18px;
                      }
                    }
                  }
                }
              }
            }
          }
          .vxe-table--fixed-right-wrapper {
            &.scrolling--middle {
              border-left: 1px solid rgba(0,0,0,.05);
              box-shadow: -2px 0 2px rgba(0,0,0,.05);
            }
          }
          .vxe-table--empty-placeholder {
            background-color: #f9f9f9;
          }
        }
      }
      & + .course-main {
        margin-top: 10px;
      }
    }
  }
</style>
